import admin from './permissions/admin';
import tutor from './permissions/tutor';
import subject_expert from './permissions/subject_expert';
import content_creator from './permissions/content_creator';
import qc from './permissions/qc';
import moderator from './permissions/moderator';

const users_permissions = {
  admin,
  tutor,
  subject_expert,
  content_creator,
  qc,
  moderator,
};

export default users_permissions;
